const operation = {
  // 获取最近在玩
  userGame: `/jyhApi/game/userGame`,
  // 获取全部游戏
  allGameList: `/jyhApi/game/pclist`,
  // 获取游戏区服
  gameServerList: `/jyhApi/game/district/listv2`,
  getServerPageList: `/jyhApi/game/district/pageList`,
  // 区服模糊查询
  FindServer: `/jyhApi/game/FindServer`,
  // 获取商品筛选项
  commodityConfig: `/jyhApi/commodity/config`,
  // 获取商品列表
  commodityList: `/jyhApi/commodity/list`,
  commodityListV2: `/jyhApi/v2/commodity/list`,
  // 我卖的/我买的
  myOrderList: `/jyhApi/order/list`,
  // 我的货架
  myList: `/jyhApi/commodity/my/sell`,
  // 我的收藏
  myCollectList: `/jyhApi/commodity/collectList`,
  // 我的还价
  myBargain: `/jyhApi/commodity/myBargain`,
  // 卖家还价
  buyUserBargain: `/jyhApi/commodity/buyUserBargain`,
  // 取消订单
  orderCancel: `/jyhApi/order/cancel`,
  // 删除订单
  orderDel: `/jyhApi/order/del`,
  // 结算
  buyinfo: `/jyhApi/order/buyinfo`,
  // 获取角色列表
  roleList: `/jyhApi/game/role/list`,
  // 下单
  place: `/jyhApi/order/place`,
  // 获取剩余支付时间
  expireTimes: `/jyhApi/order/expire`,
  // 交易币支付
  orderTradePay: `/jyhApi/pay/orderTradePay`, // 不需要短信
  orderTradePayV2: `/jyhApi/pay/orderTradePayV2`, //需要短信验证
  // 获取微信支付宝二维码支付
  getQrcode: `/jyhApi/pay/getQrcode`,
  // 支付状态
  payState: `/jyhApi/order/purchase/detail`,
  // 还价开关
  bargainSwitch: `/jyhApi/commodity/bargainSwitch`,
  // 还价状态
  bargainStatus: `/jyhApi/commodity/bargainStatus`,
  // 卖家取消砍价
  sellerCancelBargain: `/jyhApi/commodity/sellerCancelBargain`,
  // 去付款校验
  bargainPayCheck: `/jyhApi/commodity/bargainPayCheck`,
  // 商品出售类型
  commoditySellType: `/jyhApi/commodity/commoditySellType`
};

export default operation;
